import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import { IconArrowLeft, IconUpload, Table } from '@ui/src';
import { OngoingMonitoringListTypes } from '../types';
import formatOngoingMonitroing from '../helpers/format-ongoing-monitoring';
import { OrganizationType, OngoingMonitring } from '../../types';
import {
  ongoingColumns,
  ongoingColumnsLabels,
} from '../variables/ongoing-list';
import Card from '../../../../components/common/card/card';

import cn from '../styles.module.css';

const OngoingMonitoringList = ({
  type,
  setShowOngoing,
  getOngoingMonitroing,
  exportAvailable,
  setExportPdfPanelVisible,
  onRowClick,
  isLoading,
}: OngoingMonitoringListTypes) => {
  const {
    ongoingMonitoring,
    ongoingMonitoringPagination,
    ongoingMonitoringErrorsList,
  } = useAppSelector((state) => state.customerAml);

  const { customerId } = useParams();

  const formattedData = useMemo(() => {
    const data = formatOngoingMonitroing(
      ongoingMonitoring as OngoingMonitring[],
    );

    return data;
  }, [ongoingMonitoring]);

  return (
    <Card
      titleContent={
        <>
          {type !== OrganizationType.COMPANY_OFFICIAL && (
            <button
              type="button"
              className={cn.backButton}
              onClick={() => {
                setShowOngoing(false);
                getOngoingMonitroing({ id: customerId as string });
              }}
            >
              <IconArrowLeft width={13} height={11} />
              Back to AML
            </button>
          )}

          <div className={cn.ongoingTitle}>
            Ongoing monitoring
            {exportAvailable && (
              <button
                type="button"
                className={cn.ongoingExport}
                onClick={() => setExportPdfPanelVisible(true)}
              >
                <IconUpload />
                Export PDF
              </button>
            )}
          </div>
        </>
      }
    >
      <div className={cn.ongoingWrapper}>
        <div className={cn.ongoingTableWrapper}>
          <Table
            columns={ongoingColumns}
            data={formattedData || []}
            sort={{}}
            onSort={() => {}}
            filters={{}}
            columnsLabels={ongoingColumnsLabels}
            tableBodyClassName={
              !ongoingMonitoring?.length ? cn.emptyOngoing : ''
            }
            onFilterChange={() => {}}
            onRowClick={onRowClick}
            isLoading={isLoading}
            pagination={ongoingMonitoringPagination}
            take="40"
            error={ongoingMonitoringErrorsList}
            setPage={(data) =>
              getOngoingMonitroing({
                id: customerId as string,
                take: data.take,
                cursor: data.id,
              })
            }
          />
        </div>
      </div>
    </Card>
  );
};

export default OngoingMonitoringList;
